import useSWR from "swr";
import { SupportService, type PaginatedTickets, type TicketDetail } from "@/services/support.service";

export function useTickets(page = 1, limit = 20) {
  const { data, error, isLoading, mutate } = useSWR<PaginatedTickets>(
    ["support-tickets", page, limit],
    () => SupportService.getTickets(page, limit),
    { refreshInterval: 60000 }
  );

  return {
    tickets: data?.data ?? [],
    pagination: data?.pagination,
    isLoading,
    isError: !!error,
    mutate,
  };
}

export function useTicket(ticketId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TicketDetail>(
    ticketId ? `support-ticket-${ticketId}` : null,
    () => SupportService.getTicketById(ticketId!),
    { refreshInterval: 30000 }
  );

  return {
    ticket: data,
    isLoading,
    isError: !!error,
    mutate,
  };
}
